export default __webpack_public_path__ + "static/media/share_mini.a6743206.svg";